<template>
  <div class="seckill-orders-container">
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input v-model="searchParams.prodNameLike" :placeholder="$t('adminSeckillOrder.prodNamePlaceholder')"
          clearable></el-input>
      </el-col>
      <el-col :span="6">
        <el-input v-model="searchParams.buyerNameLike" :placeholder="$t('adminSeckillOrder.buyerNamePlaceholder')"
          clearable></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="handleSearch">
          {{ $t('common.search') }}
        </el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border style="width: 100%" class="margin-top">
      <el-table-column prop="shopName" :label="$t('adminSeckillOrder.shop')" align="center"></el-table-column>
      <el-table-column prop="orderId" :label="$t('adminSeckillOrder.orderId')" align="center"></el-table-column>
      <el-table-column :label="$t('adminSeckillOrder.productImage')" align="center">
        <template #default="scope">
          <el-image style="width: 50px; height: 50px; border-radius: 10px;" :src="scope.row.coverPhoto" fit="cover">
            <template #error>
              <div class="image-error">
                <el-icon>
                  <Picture />
                </el-icon>
              </div>
            </template>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="prodName" :label="$t('adminSeckillOrder.productName')" align="center"></el-table-column>
      <el-table-column prop="buyerName" :label="$t('adminSeckillOrder.buyer')" align="center"></el-table-column>
      <el-table-column prop="goodsNum" :label="$t('adminSeckillOrder.quantity')" align="center"></el-table-column>
      <el-table-column prop="killPrice" :label="$t('adminSeckillOrder.seckillPrice')" align="center"></el-table-column>
      <el-table-column prop="createTime" :label="$t('adminSeckillOrder.purchaseTime')" align="center"></el-table-column>
      <el-table-column prop="state" :label="$t('adminSeckillOrder.status')" align="center">
        <template #default="scope">
          {{ scope.row.state === 'C' ? $t('adminSeckillOrder.completed') : $t('adminSeckillOrder.pendingPayment') }}
        </template>
      </el-table-column>
      <el-table-column prop="endTime" :label="$t('adminSeckillOrder.deadline')" align="center"></el-table-column>
    </el-table>

    <el-pagination class="margin-top" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
  </div>
</template>

<script>
import { queryAdminSeckillOrder } from '@/api/group/adminSeckillOrderApi'
//import { Picture } from '@element-plus/icons-vue'

export default {
  name: 'AShopDetailSeckillOrders',
  components: {
    // Picture
  },

  data() {
    return {
      searchParams: {
        prodNameLike: '',
        buyerNameLike: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {

  },
  methods: {
    open(params) {
      this.shopId = params.shopId
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          shopId: this.shopId,
          prodNameLike: this.searchParams.prodNameLike,
          buyerNameLike: this.searchParams.buyerNameLike,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }

        const res = await queryAdminSeckillOrder(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取秒杀订单列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.seckill-orders-container {}

.search-row {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}

.image-error {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  color: #999;
}
</style>